'use client'

import { useEffect, useRef } from 'react'
import { tracking } from '@/tracking'

type Props = {
  productId: number
  productName: string
  price?: number | null
  currency?: string | null
}

export const ProductViewTracker = ({ productId, productName, price, currency }: Props) => {
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current) return
    if (!productId || !productName) return

    fired.current = true
    tracking.track(
      'Viewed product',
      {
        productId,
        productName,
        price: typeof price === 'number' ? price : undefined,
        currency: currency || undefined,
      },
      { eventId: `view-item:${productId}` }
    )
  }, [productId, productName, price, currency])

  return null
}


